import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ButtonModule } from 'primeng/button';
import { Subscription, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { LoginUserRequestModel } from 'src/app/models/request/login-user-request.model';
import { LoginService } from 'src/app/services/authentication/login.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [ButtonModule, FormsModule, ReactiveFormsModule]
})
export class LoginComponent implements OnInit, OnDestroy {
  hide: boolean = true;
  loginUserRequestModel: LoginUserRequestModel = new LoginUserRequestModel();
  listObservers: Array<Subscription> = new Array<Subscription>();
  nameWindow: string = 'Inicia Sesión';
  projectName = ProjectName.projectName;

  constructor(
    private loginService: LoginService,
    private title: Title,
    private toastHandlerService: ToastHandlerService
  ) { }

  ngOnInit(): void {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    localStorage.clear();
    this.clearDatabaseFilter();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.listObservers.forEach((sub) => sub.unsubscribe());
  }

  clearDatabaseFilter() {
    const request = indexedDB.open('Filtros');

    // Manejador de éxito de la apertura de la base de datos
    request.onsuccess = function (event: any) {
      const db = event.target.result;

      // Cierra la conexión a la base de datos
      db.close();

      // Elimina la base de datos
      indexedDB.deleteDatabase('Filtros');
    };
  }

  createDatabaseFilter() {
    const request = indexedDB.open('Filtros');

    //Creo el objeto filter:
    request.onupgradeneeded = function (event: any) {
      const db = event.target.result;

      // Crear un almacén de objetos
      const objectStore = db.createObjectStore('filtros', {
        keyPath: ['nameWindow', 'propertyName'],
      });

      // Crear un índice
      objectStore.createIndex('searchNameWindow', 'nameWindow', {
        unique: false,
      });
    };
  }

  async asyncLoginUser(changeSession: boolean) {
    localStorage.setItem(
      AuthenticationContants.keyNitCLient,
      this.loginUserRequestModel.nit
    );
    this.loginUserRequestModel.changeSession = changeSession;

    try {
      const response = await firstValueFrom(
        this.loginService.loginUser(this.loginUserRequestModel)
      );
      const days: number = +response.substring(0, response.indexOf(':'));
      if (days <= 5) {
        Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: `Por condiciones de negociación, La compañía se inactivará en ${days} día(s).`,
        }).then((result) => {
          if (result.isConfirmed) {
            const token = response.substring(response.indexOf(':') + 1);
            localStorage.setItem(
              AuthenticationContants.keyTokenLocalStorage,
              token
            );
            localStorage.setItem(
              AuthenticationContants.keyWindowsOpenedLocalStorage,
              JSON.stringify(new Array<string>())
            );

            //Crear BD de filtros:
            this.createDatabaseFilter();

            document.getElementById('btnmain')?.click();
          }
        });
      } else {
        const token = response.substring(response.indexOf(':') + 1);
        localStorage.setItem(
          AuthenticationContants.keyTokenLocalStorage,
          token
        );
        localStorage.setItem(
          AuthenticationContants.keyWindowsOpenedLocalStorage,
          JSON.stringify(new Array<string>())
        );

        //Crear BD de filtros:
        this.createDatabaseFilter();

        document.getElementById('btnmain')?.click();
      }
    } catch (error) {
      this.toastHandlerService.showToast(
        'error',
        'Ocurrió un error al iniciar sesión, por favor intente de nuevo.',
        'ERROR'
      );
      console.error(error);
    }
  }
}
